'use strict';

window.log = function(message) {
    if (window.appConfig && window.appConfig.envType === 'local') {
        console.log(message);
    }   
};